module.exports = __webpack_public_path__ + "img/map_cs01.ab0382d7.png";